//#region src/infrastructure/http-api-config.ts
var HttpApiConfig = {
	Timeout: 3e4,
	UploadTimeout: 6e4
};
//#endregion
export { HttpApiConfig };

//# sourceMappingURL=http-api-config.js.map